// extracted by css-extract-rspack-plugin
export default {"wrapper":"src-modules-app-registry-components-ApplicationStudioApp-ApplicationStudioApp-module__wrapper-w_eMm8"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"wrapper\":\"src-modules-app-registry-components-ApplicationStudioApp-ApplicationStudioApp-module__wrapper-w_eMm8\"}";
        // 1793872691891
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  